import { FormControl } from '@angular/forms';

import { Visit } from '@lib/core/models/visit.interface';

export interface MedicalDocumentItem {
  medicalRecordId: string;
  documentId: string;
  type: AppointmentType;
  documentName: string;
  createdAt: string;
}

export interface UploadingMedicalDocumentItem {
  id?: string;
  file: File;
  medicalRecordId?: string;
  documentId?: string;
  type: AppointmentType;
  documentName?: string;
  createdAt?: string;
  uploadResponse?: UploadDocumentResponse;
  processingStatus?: string;
  fileLink?: string;
  userId?: string;
}

export enum AppointmentType {
  Unknown = 'Unknown',
  Appointment = 'Appointment',
  // TODO: uncomment when Vaccination will added as one of possible medical document
  // Drugs = 'Drugs',
  InstrumentalDiagnostic = 'InstrumentalDiagnostic',
  LaboratoryService = 'LaboratoryService',
  Other = 'Other',
  PersonalDoctorAppointment = 'PersonalDoctorAppointment',
}

export enum DocumentProcessingStatus {
  InProgress = 'InProgress',
  Done = 'Done',
  Warning = 'Warning',
}

export enum DocumentOrigin {
  User = 'User',
  System = 'System',
  HealthManager = 'HealthManager',
}

export interface DocumentsGroupedByYear {
  [year: string]: MedicalDocumentItem[];
}

export interface AiDocumentsGroupedByYear {
  [year: string]: AiMedicalDocumentItem[];
}

export enum MedicalDocumentSyncStatus {
  Pending = 'pending',
  Error = 'error',
  Confirm = 'confirm',
}

export interface DiagnosisDetail {
  name: string;
  code: string;
  type: string;
}

export interface UploadDocumentResponse {
  id: string;
  userId?: string;
  appointmentId?: string;
  healthManagerTags: string[];
  memberTags: string[];
  fileLink: string;
  fileSize: number;
  fileName: string;
  type?: AppointmentType;
  providerName?: string;
  providerLocation?: string;
  executor?: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
  processingStatus: DocumentProcessingStatus;
  uploadedBy: DocumentOrigin;
  isEditable: boolean;
  isDraft: boolean;
  documentTitle?: string;
  documentDate?: string;
  executedServices: string[];
  plannedServices: string[];
  plannedMedications: string[];
  gatheredObservations: string[];
  recommendations: string[];
  notes: string[];
  diagnoses: string[];
  keywords: string[];
  documentClass?: string;
  data?: string;
  reviewed?: boolean;
  isMigration: boolean;
  fileHash: string;
  proposedUserId?: string;
  details?: MedicalDocumentDetails;
}

export interface DocumentDetailsControls {
  documentName: FormControl<string>;
  type: FormControl<AppointmentType>;
  appointment: FormControl<Visit>;
  documentDate: FormControl<Date>;
  documentTags: FormControl<string[]>;
  memberTags: FormControl<string[]>;
  belongsToUser: FormControl<boolean>;
}

export interface AiMedicalDocumentPayload {
  documentTitle: string;
  documentDate: Date;
  type?: AppointmentType;
  healthManagerTags: string[];
  memberTags: string[];
  appointmentId: string;
  description?: string;
}

export interface AiMedicalDocumentItem {
  id: string;
  userId?: string;
  appointmentId?: string;
  healthManagerTags: string[];
  memberTags: string[];
  fileLink: string;
  fileSize: number;
  fileName: string;
  type?: AppointmentType;
  providerName?: string;
  providerLocation?: string;
  executor?: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
  processingStatus: DocumentProcessingStatus;
  uploadedBy: DocumentOrigin;
  isEditable: boolean;
  isDraft: boolean;
  documentTitle?: string;
  documentDate?: string;
  executedServices: string[];
  plannedServices: string[];
  plannedMedications: string[];
  gatheredObservations: string[];
  recommendations: string[];
  notes: string[];
  diagnoses: string[];
  keywords: string[];
  documentClass?: string;
  data?: string;
  reviewed?: boolean;
  isMigration: boolean;
  fileHash: string;
  proposedUserId?: string;
  details?: MedicalDocumentDetails;
}

export interface HealthManagerTagModel {
  id: string;
  name: string;
}

export interface MedicalDocumentDetails {
  $type: string;
  doctorSpecialty?: string;
  diagnoses?: DiagnosisDetail[];
  clinicName?: string;
  address?: string;
  doctorName?: string;
}
